import OrderActions from '../actions/OrderActions';
import { Flow, Stage } from './Flow';
import { SeasonStages, CheckoutStages } from '../constants/AppConstants';


const STAGES = {
    [ SeasonStages.SEARCH ]: new Stage({
        next: function (current, { search }) {
            if (search.isValid()) {
                return SeasonStages.RESULTS;
            }
            return false;
        }
    }),

    [ SeasonStages.RESULTS ]: new Stage({
        previous: () => SeasonStages.SEARCH,
        next(current, { trip, smartcard }) {
            if (!trip.isValid()) {
                return false;
            }

            if (trip.isSmartcard() && (!smartcard || !smartcard.canLoadProduct())) {
                return false;
            }

            return CheckoutStages.DELIVERY;
        },
        nextAction: (current, state) => {
            const { trip, smartcard } = state;
            if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
                return OrderActions.createOrderForPreRegisteredSmartcard.bind(OrderActions);
            }
            return OrderActions.createOrUpdate.bind(OrderActions);
        },
        getQuery({ search, trip }) {
            search = trip ? trip.search : search;
            return search.serialize().query;
        },

        getParams({ search, trip }) {
            search = trip ? trip.search : search;
            return search.serialize().params;
        }
    }),

    [ CheckoutStages.DELIVERY ]: new Stage({
        previous: () => SeasonStages.DETAILS
    }),

    [ CheckoutStages.PAYMENT ]: new Stage({
        previous: () => SeasonStages.SEARCH
    })
};


export default new Flow(STAGES);



// WEBPACK FOOTER //
// ./src/flows/SeasonFlow.js